document.addEventListener('DOMContentLoaded', function () {
  var id = '.splide-hb';
  var splideElem = document.querySelector(id);

  new Splide(splideElem, {
    type: 'slide',
    arrows: false,
    pagination: false,
    autoplay: true,
    perPage: 1,
    perMove: 2,
    padding: {
      left: 16,
      right: 16,
  },
    gap: 16
  }).mount();
    });
